import { createFileRoute } from '@tanstack/react-router'
import { PostActions } from '@/features/post-actions'

type PostActionsSearch = {
  instanceId?: number
  packId?: number
  triggerType?: string
  jobType?: string
  templateId?: number
}

export const Route = createFileRoute('/_authenticated/automation/post-actions/')({
  component: PostActionsPage,
  validateSearch: (search: Record<string, unknown>): PostActionsSearch => ({
    instanceId: search.instanceId ? Number(search.instanceId) : undefined,
    packId: search.packId ? Number(search.packId) : undefined,
    triggerType: search.triggerType as string | undefined,
    jobType: search.jobType as string | undefined,
    templateId: search.templateId ? Number(search.templateId) : undefined,
  }),
})

function PostActionsPage() {
  return <PostActions />
}
